import { h, Component, Fragment } from 'preact';
import FooterComponent from './../components/footer.component';
import ImportantInfoComponent from './../components/important-info.component';
import InfoButtonsComponent from './../components/info-buttons.component';
import MapComponent from './../components/map.component';
import SearchComponent from './../components/search.component';
import TsunamiInfoComponent from './../components/tsunami-info.component';
import mapService from './../services/map.service';
import HeaderComponent from '../components/header.component';
import { regions } from '../config/config';
import windowService from './../services/window.service';

export default class MainView extends Component {
    constructor() {
        super();
        this.state = {
            isTsunamiInfoOpen: false,
            isImportantInfoOpen: false,
            isFooterOpen: false,
            selectedRegion: regions[0]
        };
    }

    openImportantInfo() {
        if (!this.state.isImportantInfoOpen) {
            this.setState({ isImportantInfoOpen: true });
        }
    }

    closeImportantInfo() {
        if (this.state.isImportantInfoOpen) {
            this.setState({ isImportantInfoOpen: false });
        }
    }

    openTsunamiInfo() {
        if (!this.state.isTsunamiInfoOpen) {
            this.setState({ isTsunamiInfoOpen: true });
        }
    }

    closeTsunamiInfo() {
        if (this.state.isTsunamiInfoOpen) {
            this.setState({ isTsunamiInfoOpen: false });
        }
    }

    openFooter() {
        if (!this.state.isFooterOpen) {
            this.setState({ isFooterOpen: true });
        }
    }

    closeFooter() {
        if (this.state.isFooterOpen) {
            this.setState({ isFooterOpen: false });
        }
    }

    async componentDidMount() {
        // set default region
        // zoom in on a predefined region if that's where the user lives if they have navigation permission, otherwise Hawaii
        let defaultRegion = regions.length > 0 ? regions[0] : null;

        try {
            const position = await windowService.geolocate();
            const point = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
            for (let i = 0; i < regions.length; i++) {
                const region = regions[i];
                if (google.maps.geometry.spherical.computeDistanceBetween(region.mapOptions.center, point) <= region.nearbyDistanceMeters) {
                    defaultRegion = { ...region };
                    defaultRegion.mapOptions = { ...region.mapOptions };
                    defaultRegion.mapOptions.center = point;
                    defaultRegion.mapOptions.zoom = 15;
                    break;
                }
            }
        }
        catch (err) {
            // do nothing
        }

        if (defaultRegion) {
            this.changeRegion(defaultRegion);
        }
    }

    changeRegion(region) {
        this.setState({ selectedRegion: region });
        mapService.changeRegion(region);
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <MapComponent />

                <HeaderComponent onChangeRegion={(region) => self.changeRegion(region)} selectedRegion={self.state.selectedRegion} />

                <InfoButtonsComponent openTsunamiInfo={() => self.openTsunamiInfo()} openImportantInfo={() => self.openImportantInfo()} selectedRegion={self.state.selectedRegion} />
                <SearchComponent />

                <button class="btn-footer-toggle btn-dark" onclick={() => self.openFooter()} data-ga="About">About</button>

                <TsunamiInfoComponent close={() => self.closeTsunamiInfo()} isOpen={self.state.isTsunamiInfoOpen} selectedRegion={self.state.selectedRegion} />
                <ImportantInfoComponent close={() => self.closeImportantInfo()} isOpen={self.state.isImportantInfoOpen} />
                <FooterComponent close={() => self.closeFooter()} isOpen={self.state.isFooterOpen} />
            </Fragment>
        );
    }
}
